import React from 'react';
import { Divider } from 'antd';
import { Link } from 'dva/router';
import LinesEllipsis from 'react-lines-ellipsis';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';

export default ({ id, name, pic, cata, brief, is_done }) => (
    <div style={{
        height: '124px',
        position: 'relative',
    }}>
        <Link to={`/book/detail/${id}`}>
            <div style={{
                height: '124px',
                width: '96px',
                float: 'left',
                position: 'relative',
            }} >
                <img alt='' src={pic} style={{
                    height: '124px',
                    width: '96px',
                    float: 'left',
                }} />
                <img alt='' src="https://img.cgwrite.cn/qa/up/2508/276281.png" style={{ position: 'absolute', left: '0', top: '0', width: '50px' }} />
            </div>

            <div style={{
                position: 'relative',
                marginLeft: '110px',
            }}>
                <div style={{
                    fontSize: '16px',
                    lineHeight: '22px',
                    color: '#333333',
                }}>
                    <HTMLEllipsis unsafeHTML={name} maxLine={1} />
                </div>
                <div style={{
                    marginTop: '4px',
                    fontSize: '12px',
                    lineHeight: '17px',
                    color: '#999999',
                }}>
                    {cata}<span><Divider type="vertical" />{is_done}</span>
                </div>
                <div style={{
                    marginTop: '10px',
                    fontSize: '14px',
                    lineHeight: '20px',
                    color: '#999999',
                }}>
                    <LinesEllipsis text={brief} maxLine={3} />
                </div>
            </div>
        </Link>
    </div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_3_big.js